<template>
  <div class="pdf">
    <!--头部组件开始-->
    <v-login-info>
      <div slot="goBack">
        <a class="left clearfix" href="javascript: void(0)" @click="goBackFn">
          <i class="icon-left-arrow"></i>
        </a>
      </div>
    </v-login-info>
    <!--头部组件结束-->

    <!--pdf 预览-->
    <iframe class="pdf-view" :src="url"></iframe>
  </div>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  export default {
    name: 'pdf',
    data () {
      return {
        // pdf 打开路径
        url: `/static/pdfjs/web/viewer.html?file=${this.$route.params.name}.pdf`
      }
    },
    methods: {
      // 返回目录页面
      goBackFn () {
        this.$router.push({path: `/developmentFile/${this.$route.params.pid}`})
      }
    },
    components: {
      'v-login-info': loginInfo
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "pdf.styl";
</style>



// WEBPACK FOOTER //
// src/views/pdf/pdf.vue